"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagManager = void 0;
var TagManagerSnippets_1 = require("./TagManagerSnippets");
var TagManager = /** @class */ (function () {
    function TagManager() {
    }
    TagManager.initialize = function (_a) {
        var id = _a.id, domain = _a.domain, eventData = _a.eventData, _b = _a.preview, preview = _b === void 0 ? '' : _b, _c = _a.auth, auth = _c === void 0 ? '' : _c;
        return __awaiter(this, void 0, void 0, function () {
            var gtm;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.gtm({
                            id: id,
                            domain: domain,
                            eventData: eventData || undefined,
                            preview: preview,
                            auth: auth
                        })];
                    case 1:
                        gtm = _d.sent();
                        document.head.appendChild(gtm.dataScriptResult);
                        document.head.insertBefore(gtm.scriptResult, document.head.childNodes[0]);
                        document.body.insertBefore(gtm.noScriptResult, document.body.childNodes[0]);
                        return [2 /*return*/];
                }
            });
        });
    };
    TagManager.gtm = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var snippets, noScript, script, dataScript, noScriptResult, scriptResult, dataScriptResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, TagManagerSnippets_1.TagManagerSnippets.tags(args)];
                    case 1:
                        snippets = _a.sent();
                        noScript = function () {
                            var noscript = document.createElement('noscript');
                            noscript.appendChild(snippets.iframe);
                            return noscript;
                        };
                        script = function () {
                            var script = document.createElement('script');
                            script.innerHTML = snippets.script;
                            return script;
                        };
                        dataScript = this.dataScript(snippets.eventDataVar);
                        noScriptResult = noScript();
                        scriptResult = script();
                        return [4 /*yield*/, dataScript];
                    case 2:
                        dataScriptResult = _a.sent();
                        return [2 /*return*/, {
                                noScriptResult: noScriptResult,
                                scriptResult: scriptResult,
                                dataScriptResult: dataScriptResult
                            }];
                }
            });
        });
    };
    TagManager.dataScript = function (dataLayer) {
        return __awaiter(this, void 0, void 0, function () {
            var script;
            return __generator(this, function (_a) {
                script = document.createElement('script');
                script.innerHTML = dataLayer;
                return [2 /*return*/, script];
            });
        });
    };
    TagManager.pushEvent = function (eventData) {
        return __awaiter(this, void 0, void 0, function () {
            var snippets, dataScript, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!window) {
                            return [2 /*return*/];
                        }
                        if (!window['dataLayer']) return [3 /*break*/, 3];
                        return [4 /*yield*/, TagManagerSnippets_1.TagManagerSnippets.pushEvent(eventData)];
                    case 1:
                        snippets = _c.sent();
                        dataScript = this.dataScript(snippets);
                        _b = (_a = document.head).insertBefore;
                        return [4 /*yield*/, dataScript];
                    case 2:
                        _b.apply(_a, [_c.sent(), document.head.childNodes[0]]);
                        return [2 /*return*/, true];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return TagManager;
}());
exports.TagManager = TagManager;
//# sourceMappingURL=TagManager.js.map